module.exports = __webpack_public_path__ + "img/Feature.fa9f2d55.png";